import { render, staticRenderFns } from "./SendDocumentList.vue?vue&type=template&id=110920fe&scoped=true&lang=pug"
import script from "./SendDocumentList.vue?vue&type=script&lang=ts"
export * from "./SendDocumentList.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentList.vue?vue&type=style&index=0&id=110920fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110920fe",
  null
  
)

export default component.exports